import React from "react";
import { Wrapper, Content } from "./style";

// import config from "config.json";

// import logo from "assets/img/logo_white.png";
import bg from "assets/img/bg.jpg";

//Components
import Background from "components/Background";

//3rd party
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import Menu from "components/Menu";
import { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import anime from "animejs";
import Comunicado from "./comunicado";
// import docs from "../../assets/docs.json";

export default function(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  const { slug } = useParams();
  const [localState, setLocalState] = useState({ isOpen: false });
  const [comunicadosLinks, setComunicados] = useState([]);

  useEffect(() => {
    const tgt = document.getElementsByClassName("_menu_ref")[0];

    if (!tgt) {
      return;
    }

    const toggleMenu = () => {
      // //console.log("clicou");
      setLocalState({ ...localState, isOpen: !localState.isOpen });
    };

    tgt.addEventListener("click", toggleMenu);
    return () => {
      tgt.removeEventListener("click", toggleMenu);
    };
  }, [localState.isOpen]);

  if (slug)
    return (
      <>
        {/* <Background image={bg}>
          <Wrapper>
            <Container fluid>
              <Row
                style={{
                  top: 0,
                  position: `fixed`,
                  width: `100%`,
                  zIndex: !!localState.isOpen ? 99999 : 10,
                }}
              >
                <Menu></Menu>
              </Row>
              <div id="conteudo">
                <Row className="text-center mt-0 mt-md-5">
                  <Col>
                    <Content.mainTitle>{slug}</Content.mainTitle>
                  </Col>
                </Row>
              </div>
            </Container>
          </Wrapper>
        </Background> */}
        <Comunicado slug={slug} />
      </>
    );

  useEffect(() => {
    anime
      .timeline({
        easing: `easeInOutQuad`,
        // delay: (el, i) => i * 100
      })
      .add({
        targets: [".rowUp.first"],
        translateY: [50, 0],
        scale: [1.1, 1],
        opacity: [0, 1],
      })
      .add(
        {
          targets: [".rowUp:not(.first)"],
          translateY: [50, 0],
          scale: [1.1, 1],
          opacity: [0, 1],
        },
        `-=500`
      )
      .play();
    const fetchComunicados = async () => {
      try {
        const response = await fetch(`/rmc_comunicados/comunicados.json`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log("Comunicados data:", data);
        setComunicados(data);
      } catch (error) {
        console.error("Error fetching comunicados:", error);
      }
    };
    fetchComunicados();
  }, []);

  const dataBr= (data) => {
    const [year, month, day] = data.split("-");
    return `${day}/${month}/${year}`;
  }
  return (
    <>
      <Background image={bg}>
        <Wrapper>
          <Container fluid>
            <Row
              style={{
                top: 0,
                position: `fixed`,
                width: `100%`,
                zIndex: !!localState.isOpen ? 99999 : 10,
              }}
            >
              <Menu></Menu>
            </Row>
            <div id="conteudo">
              <Row className="text-center mt-0 mt-md-5">
                <Col>
                  <Content.mainTitle>
                    Comunicados do Grupo RMC
                  </Content.mainTitle>
                  <Container>
                    <Row>
                      <Col className="col-12 col-md-6 offset-0 offset-md-3">
                        <Content.subtitle>
                          Fique bem informado com os nossos comunicados!
                        </Content.subtitle>
                      </Col>
                    </Row>
                    <Row className="text-justify">
                      <Col className="col-12 col-md-6 offset-0 offset-md-3"></Col>
                    </Row>
                    {comunicadosLinks.length ? (
                      <ul className="lista-comunicados">
                        {comunicadosLinks.map((link, i) => (
                          <li key={i}>
                            <span>{dataBr(link["date"])}</span>
                            <a
                              href={`/comunicados/${link["slug"]}`}
                              /* onClick={(e) => {
                                    // hist.push(subitem.href);
                                    e.preventDefault();
                                    dispatch({
                                      type: "PAGE.CHANGE",
                                      payload: {
                                        href: `/esg/comunicados/${link["slug"]}`,
                                      },
                                      history,
                                    });
                                  }} */
                            >
                              {link["title"]}
                            </a>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <Row className="text-center">
                        <Col>
                          <Content.paragraph>
                            Ainda não há comunicados!
                          </Content.paragraph>
                        </Col>
                      </Row>
                    )}
                  </Container>
                </Col>
              </Row>
            </div>
          </Container>
        </Wrapper>
      </Background>
    </>
  );
}
